import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotifications = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 6,
			fill: "#24A2C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 12.6667C21 11.3406 20.4732 10.0688 19.5355 9.13115C18.5979 8.19347 17.3261 7.66669 16 7.66669C14.6739 7.66669 13.4021 8.19347 12.4645 9.13115C11.5268 10.0688 11 11.3406 11 12.6667C11 18.5 8.5 20.1667 8.5 20.1667H23.5C23.5 20.1667 21 18.5 21 12.6667Z",
			stroke: "#DFF1FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4417 23.5C17.2952 23.7526 17.0849 23.9622 16.8319 24.1079C16.5789 24.2537 16.292 24.3304 16 24.3304C15.708 24.3304 15.4212 24.2537 15.1682 24.1079C14.9151 23.9622 14.7049 23.7526 14.5583 23.5",
			stroke: "#DFF1FA",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNotifications;
